import { render, staticRenderFns } from "./ArticleUpload.vue?vue&type=template&id=b2c18566&scoped=true"
import script from "./ArticleUpload.vue?vue&type=script&lang=js"
export * from "./ArticleUpload.vue?vue&type=script&lang=js"
import style0 from "./ArticleUpload.vue?vue&type=style&index=0&id=b2c18566&prod&lang=less&scoped=true"
import style1 from "./ArticleUpload.vue?vue&type=style&index=1&id=b2c18566&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c18566",
  null
  
)

export default component.exports